import turfObj from "@turf/center-of-mass";

export default function centerOfMass(features, options) {
    return turfObj(features, options);
};
